export default __webpack_public_path__ + "static/media/SWT1400.34I-35231_-20466_0.9d98e8c2.jpg";